<div class="row align-items-center justify-content-center">
  <div class="col col-xl-6 col-lg-8">
    <app-cards-basic title="Passwort vergessen?"
                     description="Wir senden Dir einen Reset-Link per E-Mail"
                     [loading]="isLoading">
      <form [formGroup]="forgotForm" (ngSubmit)="onSubmit()">
        <mat-form-field appearance="fill" class="w-100">
          <mat-label>E-Mail</mat-label>
          <input matInput
                 formControlName="email"
                 type="email"
                 required>
          @if (forgotForm.get('email')?.invalid && forgotForm.get('email')?.touched) {
            <mat-error>
              Bitte geben Sie eine gültige E-Mail-Adresse ein.
            </mat-error>
          }
        </mat-form-field>

        <button mat-flat-button
                color="primary"
                type="submit"
                class="bp-button bp-button--large w-100"
                [disabled]="forgotForm.invalid || isLoading">
          Passwort zurücksetzen
        </button>
      </form>

      @if (successMessage) {
        <p class="success-message">{{ successMessage }}</p>
      }
      @if (errorMessage) {
        <p class="error-message">{{ errorMessage }}</p>
      }
    </app-cards-basic>
  </div>
</div>
